<template>
    <div class="common-box">
        
        <div class='error-box'>  
            <img :src="imgSrc" />
            <br/>
            <span> 您的微信暂无绑定宣教信息<br/>请至公众号绑定 </span>
        </div>

    </div>
</template>

<script>

    export default {
        name: "index",
        components: {
          
        },
        data: function () {
            return {
                imgSrc:require("@/assets/image/error.png"),
            };
        },
        beforeMount: function () {
            
        },
        mounted: function () {

        },
        updated: function () {

        },
        methods: {
        }
    };
</script>

<style lang="scss" scoped>
    
    .error-box{
        width:400px;
        margin:0 auto;
        margin-top:200px;
        text-align: center;
    }
    
    .error-box img{

        width:100%;
    }
    
    .error-box span{
        
        color:#9b9b9b;
        font-size:30px;
    }
    

</style>